export default {
    'common.notification.button.accept': 'Accept',
    'common.notification.button.decline': 'Decline'
};
